import React, { Component } from 'react'
import { PATH } from "../../modules/constants"
import { logModalView } from '../../services/ga'
import history from "../../services/history"
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import { withStyles } from '@mui/styles'

const onLoginButton = () => history.push(`/${PATH.LOGIN}`)
const onRegisterLink = () => history.push(`/${PATH.REGISTER}`)

const styles = theme => ({
  text: {
    whiteSpace: "pre-wrap",
  }
})

class SubscriptionFeatureModal extends Component {

  componentDidMount() { }

  UNSAFE_componentWillUpdate(props) {
    if (props.show && !this.props.show) {
      console.log("PROBLEM HERE")
      logModalView('SubscriptionFeatureModal')
    }
  }

  render() {
    const { classes, onClose, open } = this.props

    const title = `This feature is available to subscribed and trial users`

    return (
      <Dialog open={Boolean(open)} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{title}</DialogTitle>

        <DialogContent>
          <DialogContentText className={classes.text}>If you have already registered please <a href={`/${PATH.LOGIN}`} onClick={e => { e.preventDefault(); onLoginButton() }}>log in</a> to continue</DialogContentText>
          <DialogContentText className={classes.text}>If not, you can <a href={`/${PATH.REGISTER}`} onClick={e => { e.preventDefault(); onRegisterLink() }}>register</a> now for a free trial</DialogContentText>
          <DialogContentText className={classes.text}>Or <a href="https://www.numerable.io/contact/?utm_source=350club&utm_medium=numapp&utm_campaign=subscribemodal" target="_blank" rel="noopener noreferrer">contact us</a> to discuss subscribing</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>

          <Button variant="contained" onClick={onLoginButton} color="primary">
            Login
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
export default withStyles(styles)(SubscriptionFeatureModal)

